'use strict';

var jsxRuntime = require('react/jsx-runtime');
var RadioGroup = require('../RadioGroup/RadioGroup.js');
var RadioListContainer = require('./parts/RadioListContainer.js');
var RadioListItem = require('./parts/RadioListItem.js');

/**
 * 라디오 버튼 목록을 표시하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array} props.data - 라디오 버튼 목록 데이터
 * @param {string} props.name - 라디오 그룹의 이름
 * @param {string} [props.className] - 컨테이너에 적용할 CSS 클래스
 * @param {string} [props.selectedValue] - 선택된 라디오 버튼의 값
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {Function} props.onChange - 선택 변경 시 호출되는 콜백 함수
 * @param {boolean} [props.isDisabled] - 비활성화 여부
 * @param {boolean} [props.isError] - 에러 상태 여부
 *
 * @example
 * const data = [
 *   { key: '1', label: '옵션 1', value: 'option1' },
 *   { key: '2', label: '옵션 2', value: 'option2' },
 *   { key: '3', label: '옵션 3', value: 'option3' }
 * ];
 *
 * <RadioList
 *   data={data}
 *   name="options"
 *   selectedValue="option1"
 *   onChange={(value) => console.log(value)}
 *   isDisabled={false}
 *   isError={false}
 * />
 */ const RadioList = ({ data, name, className, selectedValue, testId, onChange, isDisabled, isError })=>{
    return jsxRuntime.jsx(RadioListContainer, {
        className: className,
        testId: testId,
        children: jsxRuntime.jsx(RadioGroup, {
            name: name,
            data: data,
            selectedValue: selectedValue,
            onChange: onChange,
            isDisabled: isDisabled,
            isError: isError,
            children: (item)=>jsxRuntime.jsx(RadioListItem, Object.assign({
                    name: name
                }, item), item.key)
        })
    });
};

module.exports = RadioList;
